import React, { useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { CForm, CFormLabel, CFormInput, CButton } from '@coreui/react';
import { useNavigate } from "react-router-dom";
import AxiosInstance from '../Axios';
import { transliterate } from 'transliteration';

const CategoriesForm = (props) => {
    // console.log(props);
    let data = props.data;

    const [name, setName] = useState((data != undefined) ? data.name : '');
    const [slug, setSlug] = useState((data != undefined) ? data.slug : '');
    const [status, setStatus] = useState((data != undefined) ? data.status : '');
    const [type, setType] = useState((data != undefined) ? data.type : 'category');
    // const [parent, setParent] = useState((data != undefined) ? data.parent : '');
    // const [Props, setProps] = useState(props);
    const editorRef = useRef(null);
    // Ключ для Editor
    const apiKey = process.env.REACT_APP_TINYMCE_API_KEY;
    // Текст для popup
    const popupTextCategoryPostSuccess = "Категорію створено";
    // const popupTextSubCategoryPostSuccess = "Підкатегорію створено";
    const popupTextCategoryPutSuccess = "Категорію оновлено";

    useEffect(() => {
        setName((data != undefined) ? data.name : '');
        setSlug((data != undefined) ? data.slug : '');
        setStatus((data != undefined) ? data.status : '');
        setType((data != undefined) ? data.type : 'category');
        // setParent((data != undefined) ? data.parent : '');
    }, [data, props]);

    let navigate = useNavigate();

    const handleSubmit = event => {
        event.preventDefault();
        let slugT;
        if (editorRef.current) {
            // console.log(editorRef.current.getContent());
            if (slug == '')
                slugT = transliterate(name).replace(' ', '');
            else
                slugT = transliterate(slug).replace(' ', '');

            let article = {
                name: name,
                slug: slugT,
                description: editorRef.current.getContent(),
                status: status,
                // parent: (props.parent != undefined)? `/api/categories/${parent}`: null,
                main: (props.parent != undefined) ? false : true,
                type: type,
            };

            if (data != undefined) {
                article['parent'] = data.parent;
            } else {
                article['parent'] = (props.parent != undefined) ? `/api/categories/${props.parent}` : null;
            }


            if (data != undefined) {
                AxiosInstance.put('/categories/' + data.id, article);
                // Popup про успішні зміни
                props.toastifySuccess(popupTextCategoryPutSuccess);
            } else {
                AxiosInstance.post('/categories', article).then((response) => {
                    // console.log(response);
                    if (response.status == 201) {
                        if (props.type == 'page') {
                            // Popup про успішні зміни
                            props.toastifySuccess(popupTextCategoryPostSuccess);
                            return navigate("/category/update/" + response.data.id);
                        }
                        // if (props.type == 'sub') {
                        //     // Popup про успішні зміни
                        //     props.toastifySuccess(popupTextSubCategoryPostSuccess);
                        //     props.actionShowModal(false);
                        // }
                    }
                    return response;
                });
            }
        }
    };

    return (
        <>
            <CForm onSubmit={handleSubmit}>
                <div className='row'>
                    <div className='col-6'>
                        <div className="mb-3">
                            <CFormLabel htmlFor="exampleFormControlInput1">Назва</CFormLabel>
                            <CFormInput type="text" id="exampleFormControlInput1" value={name} onChange={(e) => setName(e.target.value)} required />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div className="mb-3">
                            <CFormLabel htmlFor="exampleFormControlInput1">Синонім</CFormLabel>
                            <CFormInput type="text" id="exampleFormControlInput2" value={slug} onChange={(e) => setSlug(e.target.value)} />
                        </div>
                    </div>
                    <div className='col-6'>

                        <div className="mb-3">
                            <CFormLabel htmlFor="exampleFormControlInput1">Статус</CFormLabel>
                            <select className="form-select" value={status} onChange={(e) => setStatus(e.target.value)} >
                                <option value="active">Активно</option>
                                <option value="disabled">Не активно</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-6'>

                        <div className="mb-3">
                            <CFormLabel htmlFor="exampleFormControlInput1">Тип</CFormLabel>
                            <select className="form-select" defaultValue={type} onChange={(e) => setType(e.target.value)} >
                                <option value="category">Категорія</option>
                                {/* <option value="taxonomy">Таксономія</option> */}
                            </select>
                        </div>
                    </div>
                </div>

                <div className="mb-3">
                    <Editor
                        apiKey={apiKey}
                        onInit={(evt, editor) => editorRef.current = editor}
                        initialValue={(data != undefined) ? data.description : ''}
                        init={{
                            height: 500,
                            menubar: 'edit view insert format tools',
                            plugins: [
                                'advlist', 'autolink',
                                'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks',
                                'fullscreen', 'insertdatetime', 'media', 'table', 'help', 'code'
                            ],
                            toolbar: 'undo redo | blocks fontname fontfamily fontsize | bold italic underline strikethrough superscript subscript | ' +
                                'backcolor forecolor |' +
                                'alignleft aligncenter alignright alignjustify | ' +
                                'bullist numlist checklist outdent indent | removeformat | table help',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}
                    />
                </div>
                <CButton className="mb-3" type="submit" color="success">Зберегти</CButton>
            </CForm>
        </>
    );
};

export default CategoriesForm;